import { jsx as _jsx } from "react/jsx-runtime";
import { SignUpInfoAI } from './sign-up-ai';
import { SignUpInfoSerp } from './sign-up-serp';
import { isAiPackage, isSerpPackage } from './billing-utils';
import { useEffect, useState } from 'react';
import { Input } from '~/common/components';
import { cx } from '~/common/utils';
import { useVuex } from '~/common/hooks';
import store from '@/store';
export const SignUpInfo = (props) => {
    const [couponPkgs, setCouponPkgs] = useState({});
    useEffect(() => {
        setCouponPkgs((prev) => {
            const next = { ...prev };
            for (const pkg of props.packages) {
                if (isSerpPackage(pkg) && !next[`${pkg.package_identity}_`]) {
                    next[`${pkg.package_identity}_`] = pkg;
                }
            }
            return next;
        });
    }, [props.packages]);
    const [coupon, setCoupon] = useState('');
    const currentPackage = (props.currentPackage &&
        couponPkgs[isAiPackage(props.currentPackage)
            ? `${props.currentPackage.package_identity}_${coupon}_${props.credits}`
            : `${props.currentPackage.package_identity}_${coupon}`]) ||
        props.currentPackage;
    if (!props.currentPackage) {
        return null;
    }
    const couponJsx = props.isBillingPage ? (_jsx(Coupon, { currentPackage: props.currentPackage, couponPkgs: couponPkgs, setCouponPkgs: setCouponPkgs, setCoupon: setCoupon, credits: props.credits })) : null;
    return isAiPackage(props.currentPackage) ? (_jsx(SignUpInfoAI, { ...props, currentPackage: currentPackage, children: couponJsx })) : (_jsx(SignUpInfoSerp, { ...props, currentPackage: currentPackage, children: couponJsx }));
};
const Coupon = ({ currentPackage, couponPkgs, setCouponPkgs, setCoupon, credits, }) => {
    const vuex = useVuex(store);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const [couponTemp, setCouponTemp] = useState(vuex.state.auth?.coupon || '');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const identity = currentPackage.package_identity;
        if (!identity) {
            return;
        }
        if (identity !== couponPkgs[identity]?.package_identity) {
            checkCoupon().catch(() => null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPackage]);
    const checkCoupon = async () => {
        const key = isAiPackage(currentPackage)
            ? `${currentPackage.package_identity}_${couponTemp}_${credits}`
            : `${currentPackage.package_identity}_${couponTemp}`;
        if (couponPkgs[key]) {
            return;
        }
        setLoading(true);
        setSuccess(false);
        const pkg = (await vuex.actions.checkCoupon({
            coupon: couponTemp,
            package_identity: currentPackage.package_identity,
            credits: isAiPackage(currentPackage) ? credits : undefined,
            isAi: isAiPackage(currentPackage),
        }));
        if (pkg) {
            setCouponPkgs((prev) => ({ ...prev, [key]: pkg }));
        }
        vuex.actions.setCoupon(couponTemp);
        setCoupon(couponTemp);
        setSuccess(!!(pkg && couponTemp));
        setError(pkg ? '' : 'Invalid coupon code');
        setLoading(false);
    };
    return (_jsx(Input, { className: cx('!mb-6 !w-[230px]', success && '[&_input]:!border-kw-green-1'), title: "Coupon", value: couponTemp, onChange: setCouponTemp, onKeyDown: (e) => {
            if (e.key === 'Enter') {
                checkCoupon().catch(() => null);
            }
        }, type: "text", errors: error ? [error] : null, children: loading && couponTemp ? (_jsx("div", { className: "kw kw-refresh-cw animate-spin" })) : (success && _jsx("div", { className: "kw kw-check-circle text-kw-green-1" })) }));
};
